import { Link } from "react-router-dom";

const friendLinks = ["光影日报", "银幕观察", "放映室笔记", "电影周刊"];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-film-line text-primary-950 text-xl" />
              </span>
              <span className="font-heading font-extrabold text-2xl text-background-50">
                91<span className="text-accent-400">电影</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-md">
              91电影是一个专业的电影资讯与影片推荐平台，致力于为电影爱好者提供最新上映电影资讯、精选影片推荐与影评分析，让每一次观影选择都更有依据。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-base">快速导航</h4>
            <ul className="flex flex-col gap-2 text-sm">
              <li><Link to="/" className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/news" className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap">电影资讯</Link></li>
              <li><Link to="/category/recommend" className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap">影片推荐</Link></li>
              <li><Link to="/search" className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap">搜索</Link></li>
              <li><Link to="/about" className="text-background-200/80 hover:text-accent-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-base">友情链接</h4>
            <ul className="flex flex-col gap-2 text-sm">
              {friendLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © 2025 91电影 · 本站为演示站点，所有影片与资讯均为虚构示范内容
          </p>
          <p className="text-xs text-background-200/60">
            本站无登录、注册、支付及后台管理功能
          </p>
        </div>
      </div>
    </footer>
  );
}